import { Container, Row, Col, Tab, Nav } from "react-bootstrap";
import { ProjectCard } from "./ProjectCard";
import { Experience } from "./Experience";
import projImg1 from "../assets/img/project-img1.png";
import projImg3 from "../assets/img/project-img3.png";
import projImg6 from "../assets/img/project-img6.jpg";
import prjMusic from "../assets/img/prj-ms.png";
import prjTerminal from "../assets/img/prj-terminal.png";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import './Css/Projects.css';
import TrackVisibility from 'react-on-screen';
import siteConfig from "../config/site.config";

export const Projects = () => {

  const projects = [
    {
      title: "Freedom.mp3",
      description: "A simple and modern music streaming platform for discovering and enjoying music.",
      imgUrl: prjMusic,
      githubUrl: "https://freedom-mp3.vercel.app/",
      type: "web"
    },
    {
      title: "Terminal.mp3",
      description: "A terminal-style music web app with a retro CLI vibe for browsing and playing tracks.",
      imgUrl: prjTerminal,
      githubUrl: "https://terminal-mp3.vercel.app/",
      type: "web"
    },
    {
      title: "iOS Music Player App",
      description: "iOS music streaming app with API integration, search, playlists, favorites, and background playback.",
      imgUrl: projImg6,
      type: "company"
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg1,
      githubUrl: "https://github.com/xqsadness",
      type: "personal"
    },
    {
      title: "Business Startup",
      description: "Design & Development",
      imgUrl: projImg3,
      githubUrl: "https://github.com/xqsadness",
      type: "personal"
    },
    {
      title: "Internal App",
      description: "Private Project at XYZ Company",
      imgUrl: projImg1,
      type: "company"
    },
    
  ];

  const handleToolClick = (link) => {
    window.open(link, '_blank');
  };

  return (
    <section className="project" id="projects">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Projects</h2>
                  <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.</p>
                  <Tab.Container id="projects-tabs" defaultActiveKey="first">
                    <Nav variant="pills" className="nav-pills mb-5 justify-content-center align-items-center" id="pills-tab">
                      <Nav.Item>
                        <Nav.Link eventKey="first">Projects</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="second">Experience</Nav.Link>
                      </Nav.Item>
                      <Nav.Item>
                        <Nav.Link eventKey="third">Tools & Platforms</Nav.Link>
                      </Nav.Item>
                    </Nav>
                    <Tab.Content>
                      <Tab.Pane eventKey="first">
                        <Row>
                          {
                            projects.map((project, index) => {
                              return (
                                <ProjectCard
                                  key={index}
                                  {...project}
                                />
                              )
                            })
                          }
                        </Row>
                      </Tab.Pane>
                      <Tab.Pane eventKey="second">
                        <Experience />
                      </Tab.Pane>
                      <Tab.Pane eventKey="third">
                        <Row className="tools-grid">
                          {siteConfig.tools.map((tool, index) => (
                            <Col key={index} xs={6} md={3} className="tool-item mb-4">
                              <div
                                className="tool-card text-center"
                                onClick={() => handleToolClick(tool.link)}
                                role="button"
                                tabIndex={0}
                              >
                                <img
                                  src={tool.icon}
                                  alt={tool.name}
                                  className="tool-icon mb-3"
                                />
                                <h5>{tool.name}</h5>
                                <p className="tool-description">{tool.description}</p>
                              </div>
                            </Col>
                          ))}
                        </Row>
                      </Tab.Pane>
                    </Tab.Content>
                  </Tab.Container>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="background"></img>
    </section>
  )
}
